export default {"src":"/_next/static/media/afca_01.f5b3ca5a.svg","height":56,"width":121,"blurWidth":0,"blurHeight":0};